import { Grid, GridColumn, GridRow } from '@bp/ui-components';
import { graphql } from 'client/gql';
import { BpCard } from 'components/BpCard/BpCard';
import { BpSubpage } from 'components/BpSubpage/BpSubpage';
import { RunningMeetingsTable } from 'components/RunningMeetingsTable/RunningMeetingsTable';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { useAvailableServicesForOrganization } from 'hooks/useAvailableServicesForOrganization';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'urql';
import styles from './RunningBBBMeetingsSubpage.module.scss';

const RunningBBBMeetingsSubpagePageQueryDocument = graphql(`
  query RunningBBBMeetingsSubpagePageData($organizationUuid: ID!, $calendarEventWhere: CalendarEventWhere!) {
    ...UseAvailableServicesForOrganizationFields
    ...RunningMeetingsTableFields
    calendarEvents(where: $calendarEventWhere) {
      uuid
      __typename
      virtualLocations {
        uuid
        running
      }
    }
  }
`);

export const RunningBBBMeetingsSubpage = () => {
  const { t } = useTranslation();
  const organizationUuid = useAuthClaims().pimAuthClaims.getOrganizationUuid();

  const [{ data }, refetch] = useQuery({
    query: RunningBBBMeetingsSubpagePageQueryDocument,
    variables: {
      calendarEventWhere: {
        organization: { uuid: organizationUuid },
      },
      organizationUuid,
    },
  });

  const bbbMeetingsLength = data?.calendarEvents.filter((e) => e.virtualLocations.some((l) => l.running)).length ?? 0;

  const bbbService = useAvailableServicesForOrganization(data).find((s) => s.service === 'BigBlueButton');

  return (
    <BpSubpage>
      <Grid className={styles['running-bbb-meetings']}>
        <GridRow mobileGap='var(--grid-row-gap)'>
          <GridColumn width={6}>
            <BpCard>
              <div className={styles.text}>{t('meetings.bookedConnections')}</div>
              <div className={styles.count}>{bbbService ? bbbService.bookedConnections : 0}</div>
            </BpCard>
          </GridColumn>
          <GridColumn width={6}>
            <BpCard>
              <div className={styles.text}>{t('meetings.usedConnections')}</div>
              <div className={styles.count}>{bbbMeetingsLength}</div>
            </BpCard>
          </GridColumn>
        </GridRow>
        <GridRow>
          <BpCard header={{ headline: t('meetings.runningMeetings') }} noPadding>
            <RunningMeetingsTable
              query={data}
              type='bbb'
              onRefetch={() => refetch({ requestPolicy: 'network-only' })}
            />
          </BpCard>
        </GridRow>
      </Grid>
    </BpSubpage>
  );
};
